import { isFeatureFlagEnabled } from '@ipfabric/ui-components/utils/featureFlags';
import { settingTypes } from '@ipfabric/utils';
import { useMemo } from 'react';
import { omit } from 'utils/object/omit';

export const useEnabledVendorApiNames = (): Partial<
  typeof settingTypes.vendorApiNames
> => {
  const isVeloCloudEnabled = isFeatureFlagEnabled(
    'ENABLE_DISCOVERY_DEVICES_VELOCLOUD',
  );
  const isArubaNewCentralEnabled = isFeatureFlagEnabled(
    'ENABLE_DISCOVERY_DEVICES_ARUBANEWCENTRAL',
  );
  return useMemo(
    () =>
      omit(
        [
          !isVeloCloudEnabled && 'velocloud',
          !isArubaNewCentralEnabled && 'arubaNewCentral',
        ],
        settingTypes.vendorApiNames,
      ),
    [isVeloCloudEnabled, isArubaNewCentralEnabled],
  );
};
